module.exports = {"data":{"page":{"id":"/opt/render/project/src/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. I will answer to the message as soon as possible.</p>","frontmatter":{"title":"Success"}},"footnote":{"id":"/opt/render/project/src/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>Pictures are copyrighted by Vivek, Priya</li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":"coralpiyu"}}}},"pathContext":{"slug":"/success/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/success.json
// module id = 791
// module chunks = 170786371021445